import { Component, OnInit } from '@angular/core';
import { observable, Observable } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {


  public num: number = 0;
  public newNum: any;
  public newNum2: any;

  options = {
    startVal: this.num,
    useEasing: true,
    duration: 2,
    decimalPlaces: 0,
  };

  interval: any;
  public currentView: any;

  constructor() { }

  ngOnInit(): void {

    this.newNum = 1111111;
    this.num = this.newNum;
    const that = this;
    this.interval = setInterval(() =>{
      that.newNum += 10;
      that.options = {
        startVal: this.num,
        useEasing: false,
        duration: 30,
        decimalPlaces: 2,
      };
      that.num = that.newNum;
    }, 30000)


this.newNum2 = 9999999;
    this.num = this.newNum;
    const thats = this;
    this.interval = setInterval(() =>{
      that.newNum += 10;
      that.options = {
        startVal: this.num,
        useEasing: false,
        duration: 30,
        decimalPlaces: 2,
      };
      thats.num = that.newNum2;
    }, 30000)


  }

  public value = 21;

  isLoading$ = new Observable<number>(subscriber => {
    var index = 1;
    setInterval(() => {
      subscriber.next(index++);
      if (index > this.value) { subscriber.complete() };
    }, 1);
  });

  isLoading_2 = new Observable<number>(subscriber => {
    let index = 500;
    setInterval(() => {
      subscriber.next(index++);
      if (index > 1821) { subscriber.complete() };
    }, 0);
  });

  isLoading_3 = new Observable<number>(subscriber => {
    let index = 1190000;
    setInterval(() => {
      subscriber.next(index++);
      if (index > 1193898) {
        subscriber.complete()
        };
    }, 0);
  });

  isLoading_4 = new Observable<number>(subscriber => {
    let index = 1101294;
    setInterval(() => {
      subscriber.next(index++);
      if (index > 1107294) { subscriber.complete() };
    }, 1);
  });



}
